import { Instance, types as t } from 'mobx-state-tree';
import { range } from 'lodash';
import { CompletionNoHintAnswerQuestion } from '../../../question-data-model/Question/_implementations/completion-no-hint-questions.store';
import { DoTestSentenceCompleteQuestion } from './do-test-sentence-complete-question.store';

export const DoTestCompletionNoHintQuestion = t
  .compose(DoTestSentenceCompleteQuestion, CompletionNoHintAnswerQuestion)
  .named('DoTestCompletionNoHintQuestion')
  .actions((self) => ({
    setParagraph(editorChange) {
      self.paragraph.editorValue = editorChange;
    },
  }))
  .views((self) => ({
    get groupName() {
      return 'Summary, Note Completion';
    },

    get formattedQuestionNo() {
      return self.no;
    },

    get bottomBarQuestionNoes() {
      return range(self.paragraph.blanks.length)
        .map((noIndex) => {
          const no = self.no + noIndex;
          return {
            no,
            answered: self.isAnswered(
              self.userAnswers.find((_u, userAnswerIndex) => userAnswerIndex === noIndex)
            ),
          };
        })
        .filter((item) => Boolean(item));
    },

    get questionCount() {
      return self.paragraph.blanks.length;
    },

    get answerCount() {
      return (self?.userAnswers || []).filter((o) => self.isAnswered(o)).length;
    },

    prepareDataForSubmit() {
      return {
        paragraph: self.paragraph,
        questionId: self.uuid,
        type: self.type as any,
        userAnswers: self.userAnswers,
      };
    },
  }));

export interface DoTestCompletionNoHintQuestionInstance
  extends Instance<typeof DoTestCompletionNoHintQuestion> {}
